import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from '../components/common/Sidebar';
import { SidebarContext } from '../context/SidebarContext';

const CashierLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <SidebarContext.Provider value={{ openMobileSidebar: () => setMobileOpen(true) }}>
      <Box sx={{ display: 'flex', minHeight: '100vh', height: '100dvh', bgcolor: '#f8f9fa', overflow: 'hidden' }}>

        {/* Sidebar: 70px spacer on desktop, zero on mobile (drawer is overlaid) */}
        <Box sx={{ width: { xs: 0, md: '70px' }, flexShrink: 0 }}>
          <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
        </Box>

        {/* Main content */}
        <Box
          component="main"
          sx={{ flexGrow: 1, minWidth: 0, minHeight: 0, height: '100%', overflow: 'hidden', bgcolor: '#f8f9fa' }}
        >
          {children}
        </Box>

      </Box>
    </SidebarContext.Provider>
  );
};

export default CashierLayout;
